export const getUrlForLink = (icon: string | null, url: string): string => {
  if (!url || !icon) return '';

  // Fonction pour nettoyer les numéros de téléphone
  const cleanPhoneNumber = (phone: string): string => {
    return phone.replace(/\s+/g, '').replace(/^00/, '+');
  };

  // Préparer les variables en dehors des blocs case
  let cleanedPhoneForCall: string;
  let cleanedPhoneForSMS: string;
  let cleanedPhoneForWhatsApp: string;

  switch (icon.toLowerCase()) {
    case 'mail':
      return url.startsWith('mailto:') ? url : `mailto:${url}`;

    case 'call':
      cleanedPhoneForCall = cleanPhoneNumber(url);
      return cleanedPhoneForCall.startsWith('tel:')
        ? cleanedPhoneForCall
        : `tel:${cleanedPhoneForCall}`;

    case 'message':
      cleanedPhoneForSMS = cleanPhoneNumber(url);
      return cleanedPhoneForSMS.startsWith('sms:')
        ? cleanedPhoneForSMS
        : `sms:${cleanedPhoneForSMS}`;

    case 'whatsapp':
      cleanedPhoneForWhatsApp = cleanPhoneNumber(url).replace(/^\+/, '');
      return `https://wa.me/${cleanedPhoneForWhatsApp}`;

    case 'telegram':
      return url.startsWith('https://t.me/') ||
        url.startsWith('https://www.t.me/')
        ? url
        : `https://t.me/${url.replace('@', '')}`;

    case 'instagram':
      return url.startsWith('https://instagram.com/') ||
        url.startsWith('https://www.instagram.com/')
        ? url
        : `https://instagram.com/${url.replace('@', '')}`;

    case 'x':
      return url.startsWith('https://x.com/') ||
        url.startsWith('https://www.x.com/')
        ? url
        : `https://x.com/${url.replace('@', '')}`;

    case 'linkedin':
      return url.startsWith('https://linkedin.com/') ||
        url.startsWith('https://www.linkedin.com/')
        ? url
        : `https://linkedin.com/in/${url.replace('@', '')}`;

    case 'tiktok':
      return url.startsWith('https://tiktok.com/') ||
        url.startsWith('https://www.tiktok.com/')
        ? url
        : `https://tiktok.com/@${url.replace('@', '')}`;

    case 'snapchat':
      return url.startsWith('https://snapchat.com/') ||
        url.startsWith('https://www.snapchat.com/')
        ? url
        : `https://snapchat.com/add/${url.replace('@', '')}`;

    case 'threads':
      return url.startsWith('https://threads.net/') ||
        url.startsWith('https://www.threads.net/')
        ? url
        : `https://threads.net/@${url.replace('@', '')}`;

    case 'spotify':
      return url.startsWith('spotify:')
        ? url
        : url.startsWith('https://open.spotify.com/')
          ? url
          : `https://open.spotify.com/${url}`;

    case 'calendly':
      return url.startsWith('https://calendly.com/') ||
        url.startsWith('https://www.calendly.com/')
        ? url
        : `https://calendly.com/${url}`;

    case 'facebook':
      return url.startsWith('https://facebook.com/') ||
        url.startsWith('https://www.facebook.com/')
        ? url
        : `https://facebook.com/${url}`;

    case 'twitch':
      return url.startsWith('https://twitch.tv/') ||
        url.startsWith('https://www.twitch.tv/')
        ? url
        : `https://twitch.tv/${url.replace('@', '')}`;

    case 'youtube':
      return url.startsWith('https://youtube.com/') ||
        url.startsWith('https://www.youtube.com/')
        ? url
        : `https://youtube.com/@${url.replace('@', '')}`;

    case 'discord':
      return url.startsWith('https://discord.gg/') ||
        url.startsWith('https://www.discord.gg/')
        ? url
        : `https://discord.gg/${url}`;

    case 'paypal':
      return url.startsWith('https://paypal.me/') ||
        url.startsWith('https://www.paypal.me/')
        ? url
        : `https://paypal.me/${url}`;

    case 'opensea':
      return url.startsWith('https://opensea.io/') ||
        url.startsWith('https://www.opensea.io/')
        ? url
        : `https://opensea.io/${url}`;

    case 'soundcloud':
      return url.startsWith('https://soundcloud.com/') ||
        url.startsWith('https://www.soundcloud.com/')
        ? url
        : `https://soundcloud.com/${url}`;

    case 'pinterest':
      return url.startsWith('https://pinterest.com/') ||
        url.startsWith('https://www.pinterest.com/')
        ? url
        : `https://pinterest.com/${url}`;

    case 'google_reviews':
      return url.startsWith('https://g.page/') ||
        url.startsWith('https://www.g.page/')
        ? url
        : `https://g.page/${url}`;

    case 'app_link':
      return url;

    case 'address':
      return url.startsWith('https://www.google.com/maps/search/') ||
        url.startsWith('https://google.com/maps/')
        ? url
        : `https://www.google.com/maps/search/${url}`;

    case 'facetime':
      cleanedPhoneForCall = cleanPhoneNumber(url);
      return `facetime:${cleanedPhoneForCall}`;
    case 'salonkee':
      return url.startsWith('https://salonkee.be/salon/') ||
        url.startsWith('https://www.salonkee.be/salon/')
        ? url
        : `https://salonkee.be/salon/${url}`;

    default:
      // If the URL does not start with http:// or https://, add https://
      if (!url.match(/^(https?:\/\/|tel:|mailto:|sms:)/)) {
        return `https://${url}`;
      }
      return url;
  }
};
